import React from 'react';
import BiaCard from '~/ui/3dbiaUI/BiaCard/BiaCard';
import logo from '~/assets/images/3dbia-icon.jpg';
import bgImage from '~/assets/images/login.jpg'; // Optional background image
import Flex from './Flex';
interface LoginWrapperProps {
  pageTitle: string;
  children: React.ReactNode;
  style?: React.CSSProperties;
}

const LoginWrapper: React.FC<LoginWrapperProps> = ({ pageTitle, children }) => (
  <Flex className="loginWrapper"
    justify='center'
    align='start'
       style={{
         background: `url(${bgImage}) no-repeat bottom center`,
         backgroundSize: 'cover',
         backgroundPosition: 'center',
         height: '100vh',
       }}>
    <div className="registrationProcess">
      <div className="w-100">
        <img
          src={logo}
          alt="3DBia Logo"
          className="mx-auto p-3"
        />
      </div>
      <BiaCard className="background-white">
        <div className="bg-primary color-white text-center py-3 border-bottom-secondary"
            style={{ fontSize: '1.7rem', fontWeight: 'bold' }}>
          <div>{pageTitle} QA</div>
        </div>

        {children}
      </BiaCard>
    </div>
  </Flex>
);

export default LoginWrapper;
